import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-stats-card-dashboard',
  templateUrl: './stats-card-dashboard.component.html',
  styleUrls: ['./stats-card-dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatsCardDashboardComponent {
  @Input() theme: 'primary' | 'success' | 'warn' | 'danger' | 'default' = 'primary';
  @Input() inverted = false;
}
